<template>
  <div class="friends-price-box">
    <div class="fpb-header">
      <span>{{ $t('product.friends.badge') }}</span>
    </div>
    <div class="fpb-body">
      <span class="fpb-info">{{ $t('product.friends.priceBox.info') }}</span>
      <fn-link
        class="fpb-link"
        no-arrow
        bold
        color="green"
        @click="openFriendsActivationModal"
      >
        {{ $t('product.friends.priceBox.link') }}
      </fn-link>
      <div class="fpb-prices">
        <span class="fpb-price">{{ friendsPrice }}</span>
        <span class="fpb-per-unit">{{ friendsPricePerUnit }}</span>
      </div>
    </div>

    <fn-modal-friends-activation
      v-if="friendsActivationModalVisible"
      @close="closeFriendsActivationModal"
    />
  </div>
</template>

<script>
export default defineComponent({
  props: {
    friendsPrice: {
      type: String,
      required: true,
    },
    friendsPricePerUnit: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    friendsActivationModalVisible: false,
  }),
  methods: {
    openFriendsActivationModal() {
      this.friendsActivationModalVisible = true;
    },
    closeFriendsActivationModal() {
      this.friendsActivationModalVisible = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.friends-price-box {
  display: grid;
  grid-template-rows: auto 1fr;

  .fpb-header {
    width: 100%;
    background-color: $color-general-background-loyalty-friends-secondary-default;
    color: $color-general-text-inverse-default;
    padding: 6px $pad;
    text-transform: uppercase;
    border-radius: map-get($border-radiuses, 'xl') map-get($border-radiuses, 'xl') 0 0;
    font-size: map-get($font-sizes, 's');
  }

  .fpb-body {
    display: grid;
    grid-template-areas:
      'info price'
      'link price';
    column-gap: $pad * 1.5;
    padding: math.div($space, 2);
    border: solid map-get($border-width, 'xs') $color-general-background-loyalty-friends-secondary-default;
    box-sizing: border-box;
    font-weight: map-get($font-weights, 'bold');
    border-radius: 0 0 map-get($border-radiuses, 'xl') map-get($border-radiuses, 'xl');
    background-color: $color-white;

    .fpb-info {
      grid-area: info;
      font-size: map-get($font-sizes, 'm');

      @include bp(m) {
        font-size: map-get($font-sizes, 'lxl');
      }
    }

    .fpb-link {
      grid-area: link;
      font-size: map-get($font-sizes, 'm');

      @include bp(m) {
        font-size: map-get($font-sizes, 'lxl');
      }
    }

    .fpb-prices {
      width: 100%;
      grid-area: price;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: end;
      line-height: map-get($font-line-heights, 's');

      .fpb-price {
        font-size: map-get($headline, 'small');
        font-weight: map-get($font-weights, 'bold');
        color: $color-general-text-promotion-discount-default;

        @include bp(m) {
          font-size: map-get($headline, 'medium');
        }
      }

      .fpb-per-unit {
        color: $color-general-text-neutral-lower;
        font-weight: map-get($font-weights, 'normal');
        font-size: map-get($font-sizes, 'm');
      }
    }
  }
}
</style>
